export default __webpack_public_path__ + "static/media/question4.88d4d803.svg";